import { IQuestionAnswer } from '@ninjacart/nc-nk-core';
import {
  Button,
  Card,
  Image,
  Paragraph,
  Text,
  ThunderNew,
  XStack,
  YStack
} from '@ninjacart/nc-nk-ui';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { t } from 'i18next';

export function AnsweredCard({ item }: { item?: IQuestionAnswer | undefined }) {
  if (!item) {
    console.log('Unable to find mod answered question!!!');
    return null;
  }
  const expertQuestion = item?.body;
  const { push } = useRouter();
  const maxLength = 50;
  const ts = (Date.now() - item.timestamp) / 1000;
  const mins = Math.floor(ts / 60);

  const conCatContent =
    expertQuestion
      ?.replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '')
      .replace(/-ff9e-48bd-9f18-f95d99d2d53a/g, '')?.length > maxLength
      ? expertQuestion
        ?.replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '')
        .replace(/-ff9e-48bd-9f18-f95d99d2d53a/g, '')
        ?.substring(0, maxLength) + '...'
      : expertQuestion
        ?.replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '')
        .replace(/-ff9e-48bd-9f18-f95d99d2d53a/g, '');

  const onViewAnswerPress = () => {
    push(`/questionDetailList/${item?.id}`);
  };

  return (
    <YStack>
      <Card
        shadowColor={'#000000'}
        shadowRadius={5}
        elevation={5}
        marginHorizontal={5}
        shadowOpacity={0.2}
        marginVertical={10}
        padding={5}
        borderWidth={1}
        backgroundColor={'#e7fbf3'}
        borderColor={'$primary'}
      >
        <XStack padding={5} justifyContent={'space-between'}>
          <XStack>
            <Text fontSize={17} color={'$usertextColor'} textTransform="uppercase" fontWeight={'600'}>
              {t('page.yourQuestion')}
            </Text>
          </XStack>
          <XStack>
            {/* <Image
              source={{
                uri: 'https://tecxsprts3.s3.amazonaws.com/1714382350558-Flash%20image.png',
              }}
              width={30}
              height={20}
              borderRadius={15}
            /> */}
            <ThunderNew width={32} height={20} />
            <Text color={'$primary'}>
              {t('page.answeredIn')} {mins}
              {t('page.mins')}
            </Text>
          </XStack>
        </XStack>

        <XStack flex={1} flexDirection="row" marginTop={5}>
          <YStack padding={7}>
            <Image
              source={{
                uri:
                  item?.medias?.[0]?.preview_url ??
                  'https://st4.depositphotos.com/1044737/30675/i/450/depositphotos_306750856-stock-photo-fruits-collection-food-background-apple.jpg',
              }}
              width={120}
              height={120}
              borderRadius={15}
            />
          </YStack>

          <YStack padding={7}>
            <YStack>
              <XStack paddingRight={1} width={'80%'}>
                <Text color={'$primary'} textTransform="uppercase" fontWeight={'600'}>
                  {t('page.question')}:
                </Text>
                <Text color={'$usertextColor'} fontWeight={'600'} numberOfLines={3} ellipsizeMode="tail" fontSize={16}>
                  {conCatContent}
                </Text>
              </XStack>
            </YStack>

            <XStack height={20} width={'100%'} position={'absolute'} bottom={0}>
              <XStack
                flexDirection="row"
                alignItems="center"
                borderTopColor={'#EEE'}
                borderTopWidth={1}
                width={'80%'}
              >
                <Button
                  backgroundColor={'$primary'}
                  theme="active"
                  fontWeight={'500'}
                  letterSpacing={'$6'}
                  borderRadius="$2"
                  color={'$qnaAnswerTextColor'}
                  width={'100%'}
                  size="$3"
                  marginBottom="$10"
                  marginTop={15}
                  fontSize={16}
                  onPress={onViewAnswerPress}
                  testID='kisan_tId_viewAnswer_click'
                >
                  {t('page.viewAnswer')}
                </Button>
              </XStack>
            </XStack>
          </YStack>
        </XStack>
      </Card>
    </YStack>
  );
}
